import { IBonusAgentConfig, IUpdateBonusAgentConfigRequest } from "@finbackoffice/clientbff-client";
import {
    FC,
    PropsWithChildren,
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { ClientBFFContext } from "../../providers";

interface IAgentConfigContext {
    agentConfig: IBonusAgentConfig | undefined;
    updateAgentConfig: (newData: IUpdateBonusAgentConfigRequest) => Promise<void>;
}
export const AgentConfigContext = createContext<IAgentConfigContext>({} as IAgentConfigContext);

export const AgentConfigProvider: FC<PropsWithChildren> = ({ children }) => {
    const client = useContext(ClientBFFContext);
    const [agentConfig, setAgentConfig] = useState<IBonusAgentConfig | undefined>();

    const updateAgentConfig = useCallback(
        async (newData: IUpdateBonusAgentConfigRequest) => {
            const response = await client.updateAgentConfig(newData);
            setAgentConfig(response);
        },
        [client, setAgentConfig],
    );

    const loadAgentConfig = useCallback(async () => {
        const response = await client.getAgentConfig();
        setAgentConfig(response);
    }, [client]);

    useEffect(() => {
        loadAgentConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const value = useMemo(
        () => ({ agentConfig, updateAgentConfig }),
        [agentConfig, updateAgentConfig],
    );

    return <AgentConfigContext.Provider value={value}>{children}</AgentConfigContext.Provider>;
};
